module.exports = __webpack_public_path__ + "img/frame (141).55a39cc6.jpg";